export const fetchAdminSearchResults = payload => ({
    type: 'FETCH_ADMIN_SEARCH_RESULTS',
    payload,
  });